import { Routes } from '@angular/router'

import { requireAuthGuard } from '@guards/authed-guard'
import { requireGuestGuard } from '@guards/unauthed-guard'
import { AuthLayout } from '@layouts/auth-layout'
import { MainLayout } from '@layouts/main-layout'
import { ValetServiceMonitoringLayout } from '@layouts/valet-service-monitoring-layout'

export const APP_ROUTES: Routes = [
	{
		path: '',
		component: MainLayout,
		canActivate: [requireAuthGuard],
		children: [
			{
				path: '',
				loadChildren: () => import('@pages/home').then(m => m.HomePage),
			},
			{
				path: 'request-car',
				loadComponent: () => import('@pages/request-car').then(m => m.RequestCarPage),
			},
			{
				path: 'overnight-report',
				loadComponent: () => {
					return import('@pages/reports/overnight-report').then(
						m => m.OvernightReportPage
					)
				},
			},
		],
	},
	{
		path: 'valet-service-monitoring',
		component: ValetServiceMonitoringLayout,
		canActivate: [requireAuthGuard],
		children: [
			{
				path: '',
				loadComponent: () =>
					import('@pages/valet-service-monitoring-page').then(
						m => m.ValetServiceMonitoringPage
					),
			},
		],
	},
	{
		path: 'auth',
		component: AuthLayout,
		canActivate: [requireGuestGuard],
		children: [
			{
				path: 'sign-in',
				loadChildren: () => import('@pages/auth/sign-in').then(m => m.SignInPage),
			},
			{
				path: '**',
				redirectTo: 'sign-in',
				pathMatch: 'full',
			},
		],
	},
	{
		path: '**',
		redirectTo: '/',
		pathMatch: 'full',
	},
]
